import * as THREE from 'three';
import EventDispatcher from "../common/EventDispatcher";
import {
    Global
} from "../common/global";

export default class Shooter {


    constructor(scene) {
        this.scene = scene;
        this.onEvents = this.onEvents.bind(this)
    }

    init() {
        this.events = EventDispatcher.getObj();

        this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.addEventListener("PLAYER_EVENTS", this.onEvents);
        this.events.addEventListener("GAME_EVENTS", this.onEvents);

        this.mixer = null;
        this.checkKickProgress = false;
    }
    onEvents(data) {
        switch (data['message']['event_type']) {
            case "create_scene":
                this.addShooter();
                break;
            case "update":
                this.update(data['message']['data']);
                break;
            case "assign_position":
                this.placeShooter(data['message']['data']);
                break;
            case "kick_ball":
                this.playKick();
                break;
            case "goal":
                this.showHappy();
                break;
            case "defend":
                this.showUnhappy();
                break;
            case "dispose":
                this.dispose();
                break;
        }
    }
    addShooter() {
        this.shooter = Global.assets['glbs'][`shooter`]['asset'].scene;
        this.scene.add(this.shooter);

        this.shooter.traverse((child) => {
            if (!child.material) return false;

            child.material.envMap = Global.envMap;
            child.material.envMapIntensity = 2;
            child.material.side = THREE.DoubleSide
        });

        this.mixer = new THREE.AnimationMixer(this.shooter)

        this.shooterIdle = THREE.AnimationClip.findByName(Global.assets['glbs'][`shooter`]['asset']['animations'], 'shooter_idel');
        this.shooterKick = THREE.AnimationClip.findByName(Global.assets['glbs'][`shooter`]['asset']['animations'], 'kick');
        this.shooterHappy = THREE.AnimationClip.findByName(Global.assets['glbs'][`shooter`]['asset']['animations'], 'celebration_2');
        this.shooterUnhappy = THREE.AnimationClip.findByName(Global.assets['glbs'][`shooter`]['asset']['animations'], 'unhappy_1');

        this.idleAnimation = this.mixer.clipAction(this.shooterIdle)
        this.kickAnimation = this.mixer.clipAction(this.shooterKick)
        this.happyAnimation = this.mixer.clipAction(this.shooterHappy)
        this.unhappyAnimation = this.mixer.clipAction(this.shooterUnhappy)



        this.kickAnimation.setLoop(THREE.LoopOnce, 1);
        this.kickAnimation.clampWhenFinished = true;

        this.happyAnimation.setLoop(THREE.LoopOnce, 1);
        this.happyAnimation.clampWhenFinished = true;

        this.unhappyAnimation.setLoop(THREE.LoopOnce, 1);
        this.unhappyAnimation.clampWhenFinished = true;


        this.mixer.addEventListener('finished', (e) => {
            if (e.action === this.kickAnimation) {
                // this.kickAnimation.stop()
                // alert("Ds")
            }
        });

        this.playIdle();
    }
    playIdle() {
        this.stopAll();
        this.idleAnimation.play()
    }
    showHappy() {
        this.stopAll();
        this.happyAnimation.play()
    }
    showUnhappy() {
        this.stopAll();
        this.unhappyAnimation.play()
    }
    stopAll() {
        this.idleAnimation.stop()
        this.kickAnimation.stop()
        this.happyAnimation.stop()
        this.unhappyAnimation.stop()
    }
    playKick() {

        this.checkKickProgress = true;
        this.stopAll();
        this.kickAnimation.play()

    }
    placeShooter(data) {

        const {
            x,
            y,
            z
        } = data['position'];

        const distanceBehindBall = 1.2; // Distance behind the ball
        const targetPoint = new THREE.Vector3(-1, 0, -0.6)
        // Calculate the direction from the ball to the target point
        const direction = new THREE.Vector3().subVectors(targetPoint, data['position']).normalize();

        // Calculate the player's position
        const playerPosition = new THREE.Vector3().copy(data['position']).addScaledVector(direction, -distanceBehindBall);
        this.shooter.position.copy(playerPosition);
        this.shooter.position.x += .1;


        // Calculate the angle to rotate the player
        const angle = Math.atan2(direction.x, direction.z);
        this.shooter.rotation.y = angle;


        this.events.dispatchEvent({
            type: "GAME_EVENTS",
            message: {
                "event_type": "set_camera_view",
                data: {
                    "position": this.shooter.position,
                    "direction": direction,
                    "rotationY": this.shooter.rotation.y
                }
            }
        });
        this.playIdle();

        // this.shooter.position.set(x+.1,y-.52,z-0.6)  
    }
    update() {
        if (this.mixer) {
            this.mixer.update(Global.delta * .01);
            if (this.checkKickProgress) {
                const kickProgress = this.kickAnimation.time / this.shooterKick.duration;
                if (kickProgress >= 0.3) {
                    this.checkKickProgress = false;
                    this.events.dispatchEvent({
                        type: "GAMESCENE_EVENTS",
                        message: {
                            "event_type": "ready_to_launch",
                            data: {}
                        }
                    });
                }
            }

        }




    }
    dispose() {
        if (this.shooter) {
            this.shooter.traverse((child) => {
                if (child.isMesh) {
                    if (child.geometry) child.geometry.dispose();
                    if (child.material) {
                        if (Array.isArray(child.material)) {
                            child.material.forEach((material) => material.dispose());
                        } else {
                            child.material.dispose();
                        }
                    }
                }
            });
            this.scene.remove(this.shooter);
            this.shooter = null;
        }
        this.events.removeEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.removeEventListener("PLAYER_EVENTS", this.onEvents);
        this.events.removeEventListener("GAME_EVENTS", this.onEvents);
    }
}